module.exports = __webpack_public_path__ + "static/media/label-8.96939847.svg";